<template>
    <!-- 考前须知 -->
    <div 
        class="content-box" 
        @click.stop="cutEdit"
        >
        <div  class="box content" >
            <div class="box-f" @click="setActiveInput(question.qid)">
                <TitleEditor 
                    class="outline-none" 
                    :qid="question.qid" 
                    :class="question.qid"  
                    :value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
                    @childValueChange="val=>{question.questionsName = val }" 
                ></TitleEditor>
            </div>
            <div class="box-icon" v-if="!isTestEdit && !istestPreview">
                <i class="el-icon-delete" @click="delQuestion(question.qid)"></i>
            </div>
        </div>

        <div class="text-box" @click="setActiveInput(question.qid)" v-if="question.questionsTypeId == 501">
            <TitleEditor 
                class="outline-none" 
                :qid="question.qid" 
                :class="question.qid"  
                :value="question.text" 
                :actionTitleEditorShow="activeInputId === question.qid"
                @childValueChange="val=>{question.text = val }" 
            ></TitleEditor>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    export default {
        name: 'QuestionOtherType',
        components: {
            TitleEditor
        },
        props: {
            paper: {
                type: Object,
                default: () => {}
            },
            // 单独的试题编辑（只能编辑当前试题 不能复制以及 移动）
            isTestEdit: {
                type: Boolean,
                default: false
            },
            question: {
                type: Object,
                default: () => {}
            },
            // 单独试题预览 不能对试题进行操作
            istestPreview: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapState(['activeInputId']),
        },
        methods: {
            ...mapActions(['setActiveInput']),
            // 点击切换模态框形式
            cutEdit() {
                let state = this.question.isedit
                this.$emit("cutEdit");
                this.question.isedit = true
            },
            // 点击删除
            delQuestion() {
                this.$emit("delQuestion", this.question.qid);
            },
        }
    }
</script>
<style scoped lang="scss">
    
.content-box{
  background-color: rgb(255, 255, 255);
}
.content{
  padding: 0 10px;
}
.box {
  display: flex;
  justify-content: space-between;
}
.box-f{
  width: 80%;
  font-size: 16px;
  font-weight: bold;
  display: flex;
}
.box-f span {
  padding-right: 15px;
}
.box-icon i {
    display: inline-block;
    margin-right: 20px;
    font-size: 18px;
}

.text-box{
    font-size: 15px;
    padding-left: 15px;
    box-sizing: border-box;
}
</style>